import React from 'react';
import { SeeAll } from '../Components/SeeAll';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../ContextAuth/Context';
import Interswitch from '../Interswitch/Interswitch';
import { getToken } from '../utils';
import Modal from '../Components/Modal';
import { LiaTimesSolid } from 'react-icons/lia';
import { Link } from 'react-router-dom';

export const Subscription = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [subScriptionData, setSubscriptionData] = useState([]);

  const [interswitchUrl, setInterSwitchUrl] = useState('');

  const userToken = getToken()?.token;
  const userId = getToken()?.user?.id;

  async function handlePayment(amount, subId) {
    // const params = {
    //   payment_gateway_id: 1,
    //   amount,
    //   type_id: 1,
    //   cx_id: 0,
    //   payment_id: 0,
    //   currency_id: 1,
    //   subscription_id: subId,
    //   user_id: userId,
    // };

    // try {
    //   setIsLoading(true);
    //   const response = await axios.get(
    //     `https://apex.loyaltyview.com/online-payment`,
    //     {
    //       params: params,
    //       headers: { Authorization: `Bearer ${userToken}` },
    //     }
    //   );

    //   console.log(response.data);
    // } catch (error) {
    //   console.log(error);
    // } finally {
    //   setIsLoading(false);
    // }

    const url = `https://apex.loyaltyview.com/online-payment?payment_gateway_id=${1}&amount=${amount}&type_id=${1}&cx_id=${0}&payment_id=${0}&subscription_id=${subId}&currency_id=${1}&user_id=${userId}
    `;

    setInterSwitchUrl(url);
    // setOpenModal(true);
  }

  useEffect(() => {
    setIsLoading(true);
    const getSubscription = async () => {
      try {
        const response = await axios.get(
          'https://apex.loyaltyview.com/api/subscription/types',

          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        console.log(response.data);
        setSubscriptionData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getSubscription();
  }, [userToken]);

  return (
    <div className=''>
      <div className='py-12 bg-f-bk mb-12 flex flex-col w-full gap-2 text-center justify-center'>
        <h2 className='font-semibold text-2xl'>Subscription Plan</h2>
        <p>
          Subscribe to any of our plan to get access to additional transaction
          benefit
        </p>
      </div>
      <div className='p-8 flex flex-col md:flex-row justify-center items-center gap-6'>
        {/* <div>
          <h2 className="font-semibold pb-4 text-lg">
            Benefit of Subscription
          </h2>
        </div> */}
        {subScriptionData?.map((data) => (
          <div
            className='w-80 rounded shadow-md bg-p-wh p-8 flex flex-col gap-6'
            key={data.id}
          >
            <h2 className='font-semibold text-lg'>{data?.name}</h2>
            <h2 className='font-semibold text-2xl'>
              ${Number(data?.usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (&#8358;{Number(data?.price)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})/
              <small className='text-xs'>{data?.duration_text}</small>
            </h2>
            <div>
              {data?.features?.map((data) => (
                <ul className='text-sm text-s-bk' key={data.id}>
                  <li>{data.feature}</li>
                </ul>
              ))}
            </div>
            <Link
              to={interswitchUrl}
              target='_blank'
              className='px-8 py-2 bg-b-mc rounded text-p-wh text-center'
              onClick={() => handlePayment(data.price, data?.id)}
              disabled={isLoading}
            >
              Subscribe Now
            </Link>
          </div>
        ))}
      </div>
      {/* <Interswitch/> */}

      {/* <Modal open={openModal}>
        <div className='w-full h-full flex items-center justify-center'>
          <iframe
            src={interswitchUrl}
            width='60%'
            height='100%'
            title='Interswitch'
            className='relative'
          ></iframe>
          <Link to={interswitchUrl}>Click</Link>
          <button
            className='absolute items-center top-20 left-2/3 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
            onClick={() => setOpenModal(false)}
          >
            <LiaTimesSolid />
          </button>
        </div>
      </Modal> */}
    </div>
  );
};
